import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { googleDriveService } from 'src/services/googleDrive';
import CloudStorageInput from '../CloudStorageInput';
import driveUrl from '../../../assets/images/google-drive.svg';

function GoogleDriveInput({ onFileLoaded, disabled, hasError }) {
  const serviceAdapter = useMemo(() => ({
    isValidUrl: (url) => googleDriveService.isValidGoogleUrl(url),
    importFromUrl: (url) => googleDriveService.importFromUrl(url),
  }), []);

  return (
    <CloudStorageInput
      service={serviceAdapter}
      icon={driveUrl}
      iconAlt="Google Drive"
      label="Cole o link de um CSV do Google Sheets"
      errorMessage="Erro ao carregar arquivo do Google Sheets."
      onFileLoaded={onFileLoaded}
      disabled={disabled}
      hasError={hasError}
    />
  );
}

GoogleDriveInput.propTypes = {
  onFileLoaded: PropTypes.func,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
};

GoogleDriveInput.defaultProps = {
  onFileLoaded: null,
  disabled: false,
  hasError: false,
};

export default GoogleDriveInput;
